/**
 * This example previously used antd-dayjs-webpack-plugin
 * (https://github.com/ant-design/antd-dayjs-webpack-plugin) to attempt to
 * replace Moment.js with Day.js, but it would crash the page when the user
 * clicked on the DatePicker. Using this custom component (following Ant Design
 * guidelines at https://ant.design/docs/react/replace-moment) instead of the
 * webpack plugin fixes that bug.
 */
import { Form } from 'antd';
import generatePicker from 'antd/lib/date-picker/generatePicker';
import locale from 'antd/lib/date-picker/locale/id_ID';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';

import classes from './index.module.less';

// require('antd/es/date-picker/style/index.less');

type Picker = 'time' | 'date' | 'week' | 'month' | 'quarter' | 'year';
type Size = 'large' | 'middle' | 'small';
type NamePath = string | number | (string | number)[];
type Props = {
	name: NamePath;
	picker?: Picker;
	format?: string;
	disabled?: boolean;
	disabledDate?: (currentDate: any) => boolean;
	useLabel?: boolean;
	label?: string;
	placeholder?: string;
	className?: string;
	rules?: object[];
	size?: Size;
	open?: boolean;
	onOpenChange?: (e?: any) => void;
	suffixIcon?: any;
	prevIcon?: any;
	bordered?: boolean;
	allowClear?: boolean;
	inputReadOnly?: boolean;
	onChange?: (e?: any) => void;
	onKeyDown?: (e?: any) => void;
	dropdownClassName?: string;
	showToday?: boolean;
	defaultValue?: any;
	defaultPickerValue?: any;
	style?: any;
};

const DatePicker = generatePicker(dayjsGenerateConfig);
const DatePickerC = (props: Props) => {
	const { inputReadOnly = true } = props;
	const isRequired = props.rules
		? props.rules.filter((r: any) => r.required === true).length > 0
		: false;

	const onKeydownDate = (e: any) => {
		if (inputReadOnly) return;

		e.target.value = e.target.value
			.replace(/^(\d\d)(\d)$/g, '$1/$2')
			.replace(/^(\d\d\/\d\d)(\d+)$/g, '$1/$2')
			.replace(/[^\d\/]/g, '');
	};

	return (
		<Form.Item
			label={props.useLabel ? props.label : ''}
			name={props.name}
			required={isRequired}
			rules={props.rules}
		>
			<DatePicker
				defaultValue={props.defaultValue}
				dropdownClassName={props.dropdownClassName ?? classes['dropdown-date-picker']}
				showToday={props.showToday}
				defaultPickerValue={props.defaultPickerValue}
				style={props.style}
				locale={locale}
				placeholder={props.placeholder ?? props.label}
				suffixIcon={props.suffixIcon}
				format={props.format}
				className={props.className}
				inputReadOnly={inputReadOnly}
				disabled={props.disabled}
				disabledDate={props.disabledDate}
				size={props.size}
				bordered={props.bordered}
				allowClear={props.allowClear}
				onChange={props.onChange}
				onKeyDown={props.onKeyDown ?? onKeydownDate}
				open={props.open}
				onOpenChange={props.onOpenChange}
			/>
		</Form.Item>
	);
};

export default DatePickerC;
